<template>
    <div
        class="ah-audit-progress"
        :class="[
            type,
            {
                reject: statusCode == 4,
                done: statusCode == 3,
                begin: statusCode == 1,
                cancel: statusCode == 5,
                large: size == 'large'
            }
        ]"
    >
        <div class="wrapper">
            <div class="bar"></div>
            <div class="span-bar" :style="{ width: spanBarWidth }"></div>
            <div class="curr-bar" v-if="data != null" :style="{ width: currBarWidth, left: currBarLeft }"></div>
            <div class="steps" v-if="data != null">
                <div class="step passed" :style="{ left: 0 }">
                    <div class="step-name">申請</div>
                    <span class="dot"></span>
                    <span class="content">
                        <div class="title">申請</div>
                        <div class="sub-title">{{ stfNam }}</div>
                        <div class="date">
                            {{ createDate | dateFormater("YYYY-MM-dd") }}
                        </div>
                    </span>
                </div>
                <div v-if="data.length == 0" class="step" style="left: 100%">
                    <div class="step-name">
                        <span v-if="type == 'payment'">
                            {{ a03Text }}
                        </span>
                        <span v-if="type == 'invoice'">
                            {{ b03Text }}
                        </span>
                    </div>
                    <span class="dot"></span>
                </div>
                <div
                    v-for="(item, index) in data"
                    :key="index"
                    class="step"
                    :class="{ passed: getPassed(index) }"
                    :style="{
                        left: ((index + 1) / data.length) * 100 + '%'
                    }"
                >
                    <div class="step-name">
                        <span v-if="item.menU_UNT == 'A02'">
                            {{ a02Text }}
                        </span>
                        <span v-else-if="item.menU_UNT == 'A03'">
                            {{ a03Text }}
                        </span>
                        <span v-else-if="item.menU_UNT == 'B02'">
                            {{ b02Text }}
                        </span>
                        <span v-else-if="item.menU_UNT == 'B03'">
                            {{ b03Text }}
                        </span>
                        <span v-else-if="item.menU_UNT == '主管'">
                            <div v-if="!item.auditors || statusCode === 4">主管審核</div>
                            <div v-else style="font-size: 9pt; line-height: 11pt">
                                <div>主管審核</div>
                                <div v-if="item.auditors.length > 0">{{ item.auditors[0].nam }}</div>
                            </div>
                        </span>
                        <span v-else-if="type === 'payment' && item.menU_UNT == '專案PM'">
                            <div v-if="item.fin === 1">專案經理</div>
                            <div v-else style="font-size: 9pt; line-height: 11pt">
                                <div>專案經理</div>
                                <div v-if="statusCode !== 4">{{ auditorPmList }}</div>
                            </div>
                        </span>
                        <span v-else-if="type === 'payment' && (item.menU_UNT == '專案經辦人' || item.menU_UNT == '專案審核人')">
                            <div v-if="item.fin === 1">專案經辦人</div>
                            <div v-else style="font-size: 9pt; line-height: 11pt">
                                <div>專案經辦人</div>
                                <div v-if="statusCode !== 4">{{ paInfo.name }}</div>
                            </div>
                        </span>
                        <span v-else>
                            {{ item.menU_UNT }}
                        </span>
                    </div>
                    <span class="dot"></span>
                    <span class="content" v-if="getPassed(index)">
                        <div class="title">
                            <span v-if="item.menU_UNT == 'A02'">
                                {{ a02Text }}
                            </span>
                            <span v-else-if="item.menU_UNT == 'A03'">
                                {{ a03Text }}
                            </span>
                            <span v-else-if="item.menU_UNT == 'B02'">
                                {{ b02Text }}
                            </span>
                            <span v-else-if="item.menU_UNT == 'B03'">
                                {{ b03Text }}
                            </span>
                            <span v-else-if="item.menU_UNT == '主管'"> 主管審核 </span>
                            <span v-else>
                                {{ item.menU_UNT }}
                            </span>
                        </div>
                        <div class="sub-title" v-if="item.stF_NAM">
                            {{ item.stF_NAM }}
                        </div>
                        <div class="date" v-if="item.sdat">
                            {{ item.sdat | dateFormater("YYYY-MM-dd") }}
                        </div>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from 'lodash';

export default {
    name: 'ah-audit-progress',
    props: {
        type: {
            type: String,
            default: 'payment',
        },
        data: {
            type: Array,
            default: () => [],
        },
        statusCode: {
            type: Number,
            default: 0,
        },
        size: {
            type: String,
            default: 'mini',
        },
        stfNam: {
            type: String,
            default: '',
        },
        createDate: {
            type: Number,
            default: 0,
        },
        a02Text: {
            type: String,
            default: '付款',
        },
        a03Text: {
            type: String,
            default: '完成',
        },
        b02Text: {
            type: String,
            default: '開立',
        },
        b03Text: {
            type: String,
            default: '入帳',
        },
        pmList: {
            type: Array,
            default: () => [],
        },
        paInfo: {
            type: Object,
            default: () => ({
                name: '',
                sno: -1,
            }),
        },
    },
    computed: {
        currBarWidth() {
            if (this.data) {
                // 已完成
                if (this.statusCode == 3) {
                    return '100%';
                }
                // 退件
                if (this.statusCode == 4) {
                    return '100%';
                }
                return `${((this.currentStepIndex + 1) / this.data.length) * 100}%`;
            }
            return 0;
        },
        currBarLeft() {
            if (this.data) {
                return this.statusCode == 4 ? 0 : `${(this.currentStepIndex / this.data.length) * 100}%`;
            }
            return 0;
        },
        spanBarWidth() {
            if (this.data) {
                // 已完成
                if (this.statusCode == 3) {
                    return '100%';
                }
                if (this.statusCode == 4) {
                    return '0%';
                }
                return `${((this.currentStepIndex + 1) / this.data.length) * 100}%`;
            }
            return 0;
        },
        currentStepIndex() {
            if (this.data) {
                for (let i = 0; i < this.data.length; i++) {
                    if (this.data[i].fin === 0) {
                        return i;
                    }
                }
            }
            return 0;
        },
        auditorPmList() {
            return _.chain(this.pmList)
                .map('nam')
                .join(',')
                .value();
        },
    },
    methods: {
        getPassed(index) {
            // all done
            if (this.statusCode == 3) {
                return true;
            }
            if (this.statusCode == 4) {
                return this.index == 0;
            }
            // not yet

            return this.currentStepIndex > index;
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.ah-audit-progress {
    height: 30px;
    width: 80%;

    &.large {
        position: relative;
        top: 22px;
        height: 85px;
        margin: 0 auto 0 auto;
        max-width: 580px;
    }

    .wrapper {
        position: relative;
        top: 10px;
        width: 100%;

        .bar {
            position: relative;
            width: 100%;
            top: 0px;
            height: 5px;
            background-color: #e4e4e4;
            border-radius: 5px;
        }

        .span-bar {
            position: absolute;
            top: -0px;
            left: 0px;
            height: 5px;
            border-radius: 10px;
            background-color: $main-color;

            // &:after {
            // position: absolute;
            // right: -6px;
            // content: "";
            // width: 15px;
            // height: 11px;
            // border-radius: 10px;
            // background-color: #FFBC00;
            // }
        }

        .curr-bar {
            // position: absolute;
            // top: -0px;
            // left: 0px;
            // height: 5px;
            // border-radius: 10px;
            // background: $main-color;
        }

        .steps {
            position: absolute;
            top: -2px;
            left: 0px;
            width: calc(100%);
            height: 5px;

            .step {
                position: absolute;

                // box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.2);
                .dot {
                    display: block;
                    position: relative;
                    width: 9px;
                    height: 9px;
                    border-radius: 5px;
                    background-color: #fff;
                    border: 2px solid #ccc;
                }

                .step-name {
                    position: absolute;
                    top: -33px;
                    left: -60px;
                    width: 120px;
                    text-align: center;
                    z-index: 1;
                    font-size: 10.5pt;
                    font-weight: bold;
                    color: #222;
                }

                .content {
                    display: none;
                    position: absolute;
                    top: 18px;
                    left: -60px;
                    width: 120px;
                    text-align: center;
                    z-index: 1;

                    .title {
                        display: none;
                        font-size: 10.5pt;
                        font-weight: bold;
                        color: #222;
                    }

                    .sub-title {
                        font-size: 9pt;
                        color: #666;
                    }

                    .date {
                        font-size: 9pt;
                        margin-top: -5px;
                        color: #666;
                    }
                }

                &.passed {
                    .dot {
                        border: 2px solid $main-color;
                    }
                }
            }
        }
    }

    &.reject {
        .span-bar {
            background-color: #f95d5d;
        }

        .steps {
            .step.passed {
                .dot {
                    border: 2px solid #f95d5d !important;
                }
            }
        }
    }

    &.done {
        .span-bar {
            background-color: #c6ecc2;
        }

        .steps {
            .step {
                .dot {
                    border: 2px solid #c6ecc2 !important;
                }
            }
        }
    }

    &.invoice.cancel {
        .bar {
            background-color: #eee;
        }

        .span-bar {
            background-color: #ccc;
        }

        .steps {
            .step {
                .dot {
                    border: 2px solid #eee !important;
                }
            }

            .step.passed {
                .dot {
                    border: 2px solid #ccc !important;
                }
            }
        }
    }

    .tooltip {
        position: fixed;
        display: block;
        height: 40px;
        line-height: 38px;
        background-color: #fff;
        padding: 0 10px 0 40px;
        border: 1px solid #eee;
        box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
        border-radius: 12px;
        z-index: 2;

        .color {
            position: absolute;
            top: 9px;
            left: 10px;
            width: 20px;
            height: 20px;
            border-radius: 5px;
            display: block;
        }

        .txt {
            display: table;

            .name {
                display: table-cell;
            }

            .value {
                display: table-cell;
                text-align: right;
                padding-left: 25px;
            }
        }
    }

    &.large {
        .wrapper > .steps > .step > .dot {
            top: -3px;
            left: -6px;
            width: 15px;
            height: 15px;
            border-radius: 15px;
            border-width: 3px;
        }

        .step-name {
            display: block;
        }

        .wrapper .steps .step .content {
            display: block;
        }
    }
}
</style>
